// const mxModule = require("mxgraph")();
// const {
//     mxCylinder, mxPoint, mxConnectionConstraint
//   } = mxModule;
import { mxCylinder, mxPoint, mxConnectionConstraint } from "../utils/graph/mxModule";

function outputPinShape() {}

outputPinShape.prototype = new mxCylinder();
outputPinShape.prototype.constructor = outputPinShape;

outputPinShape.prototype.constraints = [
    new mxConnectionConstraint(new mxPoint(0.5, 0.5), false),  // input
  ];

outputPinShape.prototype.paintVertexShape = function(c, x, y, w, h) {
  const dx = w / 50;
  const dy = h / 40;

  c.setStrokeColor('green');
  c.setFillColor('red');
  c.setStrokeWidth(1);

  c.begin();

  // Same visual shape as input pin
  c.moveTo(x + dx * 0, y + dy * 0);
  c.lineTo(x + dx * 30, y + dy * 0);
  c.lineTo(x + dx * 50, y + dy * 20);
  c.lineTo(x + dx * 30, y + dy * 40);
  c.lineTo(x + dx * 0, y + dy * 40);
 
  // Close the shape
  c.close();

  c.fillAndStroke();
};

export default outputPinShape;